'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import Modal from '@/src/app/components/Modal/Modal';
import { Dictionary } from '@/src/lib/dictionary/types';
import { eventBus } from '@/src/lib/core/event/bus';
import { EventBusName } from '@/src/lib/core/event/types';
import { DeserializedCompanyUser } from '@/src/lib/company-user/types';
import AccountCards from '@/src/app/components/Header/AccountCards/AccountCards';
import { DialogTitle } from '@headlessui/react';
import { GetUser } from '@/src/lib/auth/types';
import { DeserializedCart } from '@/src/lib/cart/glue/types/deserialized';
import { usePathname } from 'next/navigation';
import { DeserializedStore } from '@/src/lib/store/types';
export type AccountModalProps = {
  dict: Dictionary;
  user: GetUser;
  companyUsers: Array<DeserializedCompanyUser>;
  cart?: DeserializedCart;
  lang: string;
  country: string;
  store: DeserializedStore;
};
function AccountModal(t0) {
  const $ = _c(19);
  const {
    dict,
    user,
    companyUsers,
    cart,
    lang,
    country,
    store
  } = t0;
  const pathname = usePathname();
  const [showAccountModal, setShowAccountModal] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      eventBus.on(EventBusName.HEADER_NAVIGATION_CLICK_OPEN_ACCOUNT_MODAL, () => {
        setShowAccountModal(true);
      });
      eventBus.on(EventBusName.HEADER_NAVIGATION_CLICK_CLOSE_ACCOUNT_MODAL, () => {
        setShowAccountModal(false);
      });
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (pathname?.includes("/checkout") && !pathname?.includes("/success")) {
    return null;
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setShowAccountModal(false);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== dict.userProfile.changeAccountModal.title) {
    t4 = <DialogTitle as="h3" className="display-title-3xl pr-6 mb-7">{dict.userProfile.changeAccountModal.title}</DialogTitle>;
    $[3] = dict.userProfile.changeAccountModal.title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== cart || $[6] !== companyUsers || $[7] !== dict || $[8] !== lang || $[9] !== store || $[10] !== user) {
    t5 = <AccountCards dict={dict} user={user} companyUsers={companyUsers} cart={cart} lang={lang} store={store} />;
    $[5] = cart;
    $[6] = companyUsers;
    $[7] = dict;
    $[8] = lang;
    $[9] = store;
    $[10] = user;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== country || $[13] !== dict || $[14] !== lang || $[15] !== showAccountModal || $[16] !== t4 || $[17] !== t5) {
    t6 = <Modal dict={dict} lang={lang} country={country} onModalClose={t3} open={showAccountModal} size="large" simple={true}>{t4}{t5}</Modal>;
    $[12] = country;
    $[13] = dict;
    $[14] = lang;
    $[15] = showAccountModal;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}
export default AccountModal;